import { ArgyleIncomeStream, IncomeStreamType } from 'src/app/models/Argyle';
import { DraftIncomeSource, draftCompositeKey } from 'src/app/models/income-wizard-workflow';

/** Display order used by the income wizard stream walkthrough. */
export const WIZARD_STREAM_TYPE_ORDER: Record<number, number> = {
  [IncomeStreamType.WorkNumber]: 0,
  [IncomeStreamType.PayrollSync]: 1,
  [IncomeStreamType.BankSync]: 2,
  [IncomeStreamType.DocUpload]: 3,
};

export function sortStreamsForWizard(streams: ArgyleIncomeStream[]): ArgyleIncomeStream[] {
  return [...streams].sort((a, b) => {
    const oa = WIZARD_STREAM_TYPE_ORDER[a.streamType] ?? 99;
    const ob = WIZARD_STREAM_TYPE_ORDER[b.streamType] ?? 99;
    if (oa !== ob) {
      return oa - ob;
    }
    return (a.streamIdentifier ?? '').localeCompare(b.streamIdentifier ?? '');
  });
}

// Re-exports — delegates to model methods so existing imports keep working.
export function draftKeyFromStream(stream: ArgyleIncomeStream): string {
  return stream.compositeKey;
}

// export function draftKeyFromDraft(d: DraftIncomeSource): string {
//   return draftCompositeKey(d);
// }

export function normalizeArgyleIncomeStream(raw: ArgyleIncomeStream): ArgyleIncomeStream {
  return ArgyleIncomeStream.normalize(raw);
}

export function streamDisplayLabel(stream: ArgyleIncomeStream): string {
  return stream.displayLabel;
}
